exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss"), "");
// Module
exports.push([module.id, ".text-cell-ellipsize-5mt9iJYjmwr{}\n", ""]);
// Exports
exports.locals = {
	"ellipsize": "text-cell-ellipsize-5mt9iJYjmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss").locals["ellipsize"] + ""
};